/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DefaultModal from '../nsmp-view/DefaultModal';
import NsmpAnexoModal from '../nsmp-view/NsmpAnexoModal';
import ApoioDigitacaoPanel from './components/ApoioDigitacaoPanel';
import VisaoDigitacaoNsmp from './digitacao-view/VisaoDigitacaoNsmp';
import { useVisaoNsmp } from './digitacao-view/useVisaoNsmp';
import { useParticipacaoMode } from './hooks/useParticipacaoMode';
import { isAnexoNsmp } from '../utils/nsmpRowTypes';
import { podeVerVisaoDigitacao } from '../../../../helpers/digitacaoAntecipada';
import * as selectorsNsir from '../../../../store/nsir/reducer';
import * as selectorsNsmp from '../../../../store/nsmp/reducer';
import * as selectorsAuth from '../../../../store/auth/reducer';

const MtBtNsmpModal = (props) => {
  const {
    nsirData,
    nsirStatus,
    nsmps: reduxNsmps,
    contextNsmps,
    selectedId,
    readOnly,
    participacaoMode: participacaoModeProp,
    podeForcarEnvio,
    userId,
    userRole,
    nsmpSelected,
    onEnviado,
    procedimentos,
    procedimentosLoading,
  } = props;

  const nsmps = contextNsmps || reduxNsmps;

  const [digitacaoRefreshKey, setDigitacaoRefreshKey] = useState(0);
  const [focoDocumento, setFocoDocumento] = useState(null);
  const { visao: visaoPreferida, alternar: alternarVisao } = useVisaoNsmp();

  const participacaoModeFromHook = useParticipacaoMode({
    nsirData,
    userId,
    userRole,
    nsmps,
  });
  const participacaoMode = participacaoModeProp || participacaoModeFromHook;

  const listRow = selectedId ? (nsmps || []).find((r) => r.id === selectedId) : null;
  const loadedRow = selectedId && nsmpSelected && nsmpSelected.id === selectedId ? nsmpSelected : null;
  const nsmpRow = loadedRow || listRow;
  const readOnlyEffective = readOnly || participacaoMode === 'CONSULTA';
  const isAnexo = [listRow, loadedRow].some((row) => row && isAnexoNsmp(row));

  if (isAnexo) {
    return <NsmpAnexoModal {...props} readOnly={readOnlyEffective} />;
  }

  // A visão de Digitação é do responsável pela digitação (digitador ou admin); para os demais, a Completa.
  const podeVisaoDigitacao = Boolean(selectedId) && podeVerVisaoDigitacao({
    status: nsirStatus,
    digitadorId: nsirData?.digitadorId,
    userId,
    userRole,
    digitacaoAntecipada: nsirData?.digitacaoAntecipada,
  });
  const visao = podeVisaoDigitacao && visaoPreferida === 'digitacao' ? 'digitacao' : 'completa';

  const renderVisaoDigitacao = (values) => (
    <VisaoDigitacaoNsmp
      values={values}
      procedimentos={procedimentos}
      onAbrirDocumento={(id) => setFocoDocumento({ id, n: Date.now() })}
    />
  );

  const asideContent = selectedId ? (
    <ApoioDigitacaoPanel
      data={procedimentos}
      loading={procedimentosLoading}
      nsmpId={selectedId}
      nsmpRow={nsmpRow}
      readOnly={readOnlyEffective}
      participacaoMode={participacaoMode}
      podeForcarEnvio={podeForcarEnvio}
      userId={userId}
      digitacaoKey={digitacaoRefreshKey}
      foco={focoDocumento}
      onReprocessDone={() => setDigitacaoRefreshKey((k) => k + 1)}
      onEnviado={onEnviado}
    />
  ) : null;

  const modalProps = { ...props };
  delete modalProps.procedimentos;
  delete modalProps.procedimentosLoading;

  return (
    <DefaultModal
      {...modalProps}
      readOnly={readOnlyEffective}
      asideContent={asideContent}
      visao={visao}
      onAlternarVisao={podeVisaoDigitacao ? alternarVisao : undefined}
      renderVisaoDigitacao={renderVisaoDigitacao}
    />
  );
};

MtBtNsmpModal.propTypes = {
  nsirData: PropTypes.object.isRequired,
  nsirStatus: PropTypes.string,
  nsmps: PropTypes.array,
  contextNsmps: PropTypes.array,
  nsmpSelected: PropTypes.object,
  selectedId: PropTypes.string,
  readOnly: PropTypes.bool,
  participacaoMode: PropTypes.string,
  podeForcarEnvio: PropTypes.bool,
  userId: PropTypes.string,
  userRole: PropTypes.string,
  onEnviado: PropTypes.func,
  procedimentos: PropTypes.object,
  procedimentosLoading: PropTypes.bool,
};

MtBtNsmpModal.defaultProps = {
  nsirStatus: undefined,
  nsmps: [],
  contextNsmps: null,
  nsmpSelected: {},
  selectedId: undefined,
  readOnly: false,
  participacaoMode: null,
  podeForcarEnvio: false,
  userId: null,
  userRole: null,
  onEnviado: undefined,
  procedimentos: null,
  procedimentosLoading: false,
};

const mapStateToProps = (state) => ({
  nsirData: selectorsNsir.getNsirSelected(state),
  nsirStatus: selectorsNsir.getNsirStatus(state),
  nsmpSelected: selectorsNsmp.getNsmpSelected(state),
  nsmps: selectorsNsmp.getNsmps(state),
  userId: selectorsAuth.getUserId(state),
  userRole: selectorsAuth.getRole(state),
});

export default connect(mapStateToProps)(MtBtNsmpModal);
